import { c as _c } from "react/compiler-runtime";
import { graphqlClient } from "@/lib/graphql-client";
import { queryClient } from "@/lib/tanstack/query-client";
import { CreateCustomerMediaMutation, DeleteCustomerMediaMutation } from "@/mutations";
import { useMutation } from "@tanstack/react-query";
export function useAddCustomerMedia() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp,
      onSuccess: _temp2,
      onError: _temp3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}
function _temp3(error) {
  console.error("error", error);
}
function _temp2() {
  queryClient.invalidateQueries({
    queryKey: ["customer-medias"]
  });
}
async function _temp(t0) {
  const {
    tempFileName,
    contentType
  } = t0;
  const response = await graphqlClient.request(CreateCustomerMediaMutation, {
    tempFileName,
    contentType
  });
  return response.addCustomerMedia;
}
export function useRemoveCustomerMedia(options) {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = {
      mutationFn: _temp4,
      onSuccess: data => {
        queryClient.invalidateQueries({
          queryKey: ["customer-medias"]
        });
        options?.onSuccess?.(data);
      },
      onError: error => {
        console.error("error", error);
        options?.onError?.(error);
      }
    };
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}
async function _temp4(t0) {
  const {
    mediaId
  } = t0;
  const response = await graphqlClient.request(DeleteCustomerMediaMutation, {
    mediaId
  });
  return response.removeMedia;
}